export const PAYMENT_METHODS_RESET_STATE = 'PAYMENT_METHODS_RESET_STATE';
export const PAYMENT_METHODS_CURRENT_ITEM = 'PAYMENT_METHODS_CURRENT_ITEM';

export const PAYMENT_METHODS_REQUEST_LOADING = 'PAYMENT_METHODS_REQUEST_LOADING';
export const PAYMENT_METHODS_REQUEST_SUCCESS = 'PAYMENT_METHODS_REQUEST_SUCCESS';
export const PAYMENT_METHODS_REQUEST_FAILED = 'PAYMENT_METHODS_REQUEST_FAILED';

export const PAYMENT_METHODS_CURRENT_ACTION = 'PAYMENT_METHODS_CURRENT_ACTION';
export const PAYMENT_METHODS_RESET_ACTION = 'PAYMENT_METHODS_RESET_ACTION';